import script from "./VideoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCard.vue?vue&type=script&setup=true&lang=js"

import "./VideoCard.vue?vue&type=style&index=0&id=7dcd2532&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dcd2532"]])

export default __exports__